import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import * as VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

const fb = require('./firebase/firebase')

Vue.config.productionTip = false

let app
fb.auth.onAuthStateChanged(() => {
  if(!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
